function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditUserAddress from "./EditUserAddress";
import UserAddress from "./UserAddress";
import { ANIMATION_TIMEOUT, BILLING_FORM, BILLING_FORM_TYPE, CHANGE_PASSWORD, DELETE_ACCOUNT, DELETE_ACCOUNT_IS_FORM, DELIVERY_FORM, DELIVERY_FORM_ENABLED, DELIVERY_FORM_TYPE, ROUTE_ACCOUNT_DELETE, SAME_ADDRESS_CHECKBOX, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS } from "@config/constants";
import { closeModal } from "@common/actions";
import { editBillingDetails, getFullUserDetails } from "@common/actions/user-details";
import Spinner from "@common/components/Spinner";
var ProfileInformation = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ProfileInformation, Component);
    var _super = _create_super(ProfileInformation);
    function ProfileInformation(props) {
        _class_call_check(this, ProfileInformation);
        var _this;
        _this = _super.call(this, props);
        var userDetails = props.userDetails;
        var _ref = userDetails ? userDetails : false, sameAddress = _ref.sameAddress, cf_marketing = _ref.cf_marketing;
        _this.state = {
            isEditBillingOpen: false,
            isEditDeliveryOpen: false,
            shouldSubmitForm: false,
            sameAddress: sameAddress || false,
            sameAddressRequestPending: false,
            cf_marketing: cf_marketing || false,
            cfMarketingRequestPending: false,
            isDeliveryFormValid: false,
            isBillingFormValid: false,
            validateForms: false,
            shouldToggleWithTransition: false,
            billingWillUnmount: false,
            shippingWillUnmount: false,
            editBillingWillUnmount: false,
            editShippingWillUnmount: false,
            userLoading: []
        };
        _this.toggleEditForm = _this.toggleEditForm.bind(_assert_this_initialized(_this));
        _this.allowFormSubmit = _this.allowFormSubmit.bind(_assert_this_initialized(_this));
        _this.toggleSameAddress = _this.toggleSameAddress.bind(_assert_this_initialized(_this));
        _this.validateForms = _this.validateForms.bind(_assert_this_initialized(_this));
        _this.setFormValidity = _this.setFormValidity.bind(_assert_this_initialized(_this));
        _this.renderBillingForm = _this.renderBillingForm.bind(_assert_this_initialized(_this));
        _this.renderShippingForm = _this.renderShippingForm.bind(_assert_this_initialized(_this));
        _this.renderOrderForms = _this.renderOrderForms.bind(_assert_this_initialized(_this));
        _this.updateAddressCardsState = _this.updateAddressCardsState.bind(_assert_this_initialized(_this));
        _this.setUserLoad = _this.setUserLoad.bind(_assert_this_initialized(_this));
        _this.callbackOnSuccessfulAddressChange = _this.callbackOnSuccessfulAddressChange.bind(_assert_this_initialized(_this));
        _this.toggleMarketingNotifications = _this.toggleMarketingNotifications.bind(_assert_this_initialized(_this));
        _this.renderSameAddressCheckbox = _this.renderSameAddressCheckbox.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(ProfileInformation, [
        {
            /**
     * Triggers validation of the forms
     */ key: "validateForms",
            value: function validateForms(validateForms) {
                this.setState({
                    validateForms: validateForms
                });
            }
        },
        {
            /**
     * Sets the form validity
     * @params isDeliveryForm {boolean} isValid {boolean}
     */ key: "setFormValidity",
            value: function setFormValidity(isDeliveryForm, isValid) {
                this.setState(function() {
                    return _define_property({}, "is".concat(isDeliveryForm ? "Delivery" : "Billing", "FormValid"), isValid);
                });
            }
        },
        {
            /**
     * Triggers the form submit
     * @params shouldSubmitForm {boolean}
     */ key: "allowFormSubmit",
            value: function allowFormSubmit(shouldSubmitForm) {
                this.setState({
                    shouldSubmitForm: shouldSubmitForm
                });
            }
        },
        {
            /**
     * Callback passed to edit form to execute on success change of address
     * @param isDeliveryAddressForm {boolean}
     */ key: "callbackOnSuccessfulAddressChange",
            value: function callbackOnSuccessfulAddressChange(isDeliveryAddressForm) {
                if (isDeliveryAddressForm) {
                    this.toggleEditForm(DELIVERY_FORM);
                } else {
                    this.toggleEditForm(BILLING_FORM);
                }
                if (this.props.order) {
                    this.props.order.callbackOnSuccessfulAddressChange(isDeliveryAddressForm ? DELIVERY_FORM_TYPE : BILLING_FORM_TYPE, true);
                }
                this.setUserLoad(false);
            }
        },
        {
            /**
     * Toggles between the closed and opened form state
     * The timeouts are applied so that the components can toggle with css transitions before unmounting
     * @params formType {number}
     */ key: "toggleEditForm",
            value: function toggleEditForm(formType) {
                var _this = this;
                this.setState({
                    shouldToggleWithTransition: true
                });
                if (formType === BILLING_FORM) {
                    if (this.state.isEditBillingOpen) {
                        this.setState(function() {
                            return {
                                editBillingWillUnmount: true
                            };
                        });
                        setTimeout(function() {
                            _this.setState(function() {
                                return {
                                    isEditBillingOpen: false
                                };
                            });
                            _this.setState(function() {
                                return {
                                    editBillingWillUnmount: false
                                };
                            });
                        }, ANIMATION_TIMEOUT);
                    } else {
                        this.setState(function() {
                            return {
                                billingWillUnmount: true
                            };
                        });
                        setTimeout(function() {
                            _this.setState(function() {
                                return {
                                    isEditBillingOpen: true
                                };
                            });
                            _this.setState(function() {
                                return {
                                    billingWillUnmount: false
                                };
                            });
                        }, ANIMATION_TIMEOUT);
                    }
                } else if (formType === DELIVERY_FORM) {
                    if (this.state.isEditDeliveryOpen) {
                        this.setState(function() {
                            return {
                                editShippingWillUnmount: true
                            };
                        });
                        setTimeout(function() {
                            _this.setState(function() {
                                return {
                                    isEditDeliveryOpen: false
                                };
                            });
                            _this.setState(function() {
                                return {
                                    editShippingWillUnmount: false
                                };
                            });
                        }, ANIMATION_TIMEOUT);
                    } else {
                        this.setState(function() {
                            return {
                                shippingWillUnmount: true
                            };
                        });
                        setTimeout(function() {
                            _this.setState(function() {
                                return {
                                    isEditDeliveryOpen: true
                                };
                            });
                            _this.setState(function() {
                                return {
                                    shippingWillUnmount: false
                                };
                            });
                        }, ANIMATION_TIMEOUT);
                    }
                }
            }
        },
        {
            key: "toggleSameAddress",
            value: /**
     * Toggles sameAddress checkbox current state
     */ function toggleSameAddress(shouldSendRequest) {
                var _this = this;
                return _async_to_generator(function() {
                    var sameAddress, _this_props, i18n, enqueueSnackbar, userDetails, token, data, response, error, fieldError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                sameAddress = !_this.state.sameAddress;
                                if (!shouldSendRequest) return [
                                    3,
                                    7
                                ];
                                _this_props = _this.props, i18n = _this_props.i18n, enqueueSnackbar = _this_props.enqueueSnackbar, userDetails = _this_props.userDetails;
                                token = _this.props.authentication.token;
                                data = {
                                    token: token,
                                    sameAddress: sameAddress
                                };
                                if (sameAddress) {
                                    data.subscription = {
                                        shippingAddress: _object_spread_props(_object_spread({}, userDetails.billingAddress), {
                                            gdprShipping: true
                                        })
                                    };
                                }
                                _this.setState({
                                    sameAddressRequestPending: true
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.props.editBillingDetails(data)
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.props.getFullUserDetails()
                                ];
                            case 3:
                                _state.sent();
                                _this.setState({
                                    sameAddressRequestPending: false,
                                    sameAddress: sameAddress
                                });
                                enqueueSnackbar(i18n.snackbar.deliveryAddressEditSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                fieldError = error.error_info.description;
                                _this.setState({
                                    sameAddress: false
                                });
                                if (fieldError) {
                                    enqueueSnackbar(i18n.snackbar.deliveryAddressEditFail, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                _this.setState(function() {
                                    return {
                                        sameAddress: sameAddress
                                    };
                                });
                                _state.label = 8;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * When in user account - renders same address checkbox if it's billing form
     * When in order - renders same address checkbox only if billing address is required
     * @returns {ReactElement || null}
     */ key: "renderSameAddressCheckbox",
            value: function renderSameAddressCheckbox(isDeliveryAddressForm, shouldSendRequest) {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, order = _this_props.order;
                var _this_state = this.state, sameAddress = _this_state.sameAddress, sameAddressRequestPending = _this_state.sameAddressRequestPending;
                var sameAddressCheckbox = !isDeliveryAddressForm ? /*#__PURE__*/ _jsx("div", {
                    className: "same-address-checkbox-container".concat(sameAddressRequestPending ? " disabled" : ""),
                    children: /*#__PURE__*/ _jsx(FormControlLabel, {
                        className: "same-address-checkbox",
                        control: /*#__PURE__*/ _jsx(Checkbox, {
                            classes: {
                                checked: "ux-checked"
                            },
                            checked: !!sameAddress,
                            type: "checkbox",
                            value: SAME_ADDRESS_CHECKBOX,
                            onChange: function() {
                                return _this.toggleSameAddress(shouldSendRequest);
                            }
                        }),
                        label: i18n.account.sameAddress,
                        classes: {
                            root: "ux-checkbox-label-root",
                            label: "ux-checkbox-label tiny-font"
                        }
                    })
                }) : null;
                if (order) {
                    sameAddressCheckbox = order.showShippingAddress ? sameAddressCheckbox : null;
                }
                return sameAddressCheckbox;
            }
        },
        {
            /**
     * Render account footer in profile
     * @returns {ReactElement}
     */ key: "renderAccountFooter",
            value: function renderAccountFooter() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, componentMap = _this_props.componentMap, componentName = _this_props.componentName, toggleComponent = _this_props.toggleComponent;
                var childProps = componentMap[componentName].childProps;
                var _this_state = this.state, isEditBillingOpen = _this_state.isEditBillingOpen, isEditDeliveryOpen = _this_state.isEditDeliveryOpen, sameAddress = _this_state.sameAddress, userLoading = _this_state.userLoading;
                var footerClasses = isEditDeliveryOpen || isEditBillingOpen ? "" : "absolute";
                if (isEditBillingOpen && sameAddress) {
                    footerClasses = "absolute";
                }
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-footer ".concat(footerClasses),
                    children: !isEditDeliveryOpen && !isEditBillingOpen ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                classes: {
                                    label: "ux-button-label"
                                },
                                color: "primary",
                                onClick: function() {
                                    if (DELETE_ACCOUNT_IS_FORM) {
                                        _this.props.history.push(ROUTE_ACCOUNT_DELETE);
                                        _this.props.closeModal();
                                        return;
                                    }
                                    toggleComponent(componentMap[DELETE_ACCOUNT].componentName, childProps);
                                },
                                className: "delete-account-button button-no-background float-left",
                                children: i18n.account.deleteAccount
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                color: "primary",
                                classes: {
                                    label: "ux-button-label"
                                },
                                onClick: function() {
                                    return toggleComponent(componentMap[CHANGE_PASSWORD].componentName, childProps);
                                },
                                className: "change-password-button button-no-background float-right",
                                children: i18n.account.changePassword
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                classes: {
                                    label: "ux-button-label"
                                },
                                onClick: function() {
                                    if (isEditBillingOpen) {
                                        _this.toggleEditForm(BILLING_FORM);
                                    }
                                    if (isEditDeliveryOpen) {
                                        _this.toggleEditForm(DELIVERY_FORM);
                                    }
                                    _this.setState({
                                        sameAddress: _this.props.userDetails.sameAddress
                                    });
                                },
                                className: "button-no-background go-back-button raised half-width float-left center-vertical",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-keyboard-arrow-right"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: i18n.common.back
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                classes: {
                                    label: "ux-button-label"
                                },
                                onClick: function() {
                                    return _this.validateForms(true);
                                },
                                className: "button raised half-width float-right center-vertical send-form-button",
                                children: userLoading.length > 0 ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-save"
                                        }),
                                        i18n.account.save
                                    ]
                                })
                            })
                        ]
                    })
                });
            }
        },
        {
            /**
     * Render billing info and edit forms
     * @param commonInformationCardProps {object}
     * @param commonEditFormProps {object}
     * @returns {ReactElement}
     */ key: "renderBillingForm",
            value: function renderBillingForm(commonInformationCardProps, commonEditFormProps) {
                var template = null;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, order = _this_props.order;
                var _this_state = this.state, isEditBillingOpen = _this_state.isEditBillingOpen, editBillingWillUnmount = _this_state.editBillingWillUnmount, billingWillUnmount = _this_state.billingWillUnmount, sameAddress = _this_state.sameAddress;
                var billingAddress = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.billingAddress) ? userDetails.billingAddress : {};
                template = /*#__PURE__*/ _jsx(UserAddress, {
                    classes: "invoice-information",
                    title: i18n.account.invoiceInformation,
                    subTitle: i18n.account.invoiceInformationDesc,
                    isDeliveryAddressForm: false,
                    i18n: i18n,
                    willComponentUnmount: billingWillUnmount
                });
                if (Object.keys(billingAddress).length > 0) {
                    billingAddress.gdprBilling = userDetails.gdprBilling;
                    billingAddress.countryName = userDetails.countryNameBilling;
                    if (isEditBillingOpen) {
                        template = /*#__PURE__*/ _jsx(EditUserAddress, _object_spread({
                            classes: "edit-invoice-information",
                            title: i18n.account.invoiceInformation,
                            subTitle: i18n.account.invoiceInformationDesc,
                            address: billingAddress,
                            order: order,
                            sameAddress: sameAddress,
                            isDeliveryAddressForm: false,
                            willComponentUnmount: editBillingWillUnmount,
                            renderSameAddressCheckbox: this.renderSameAddressCheckbox
                        }, commonEditFormProps));
                    } else {
                        template = /*#__PURE__*/ _jsx(UserAddress, _object_spread({
                            classes: "invoice-information",
                            title: i18n.account.invoiceInformation,
                            subTitle: i18n.account.invoiceInformationDesc,
                            order: order,
                            isDeliveryAddressForm: false,
                            willComponentUnmount: billingWillUnmount,
                            address: billingAddress,
                            userDetails: userDetails
                        }, commonInformationCardProps));
                    }
                }
                return template;
            }
        },
        {
            /**
     * Render delivery info and edit form
     * @param commonInformationCardProps {object}
     * @param commonEditFormProps {object}
     * @returns {ReactElement}
     */ key: "renderShippingForm",
            value: function renderShippingForm(commonInformationCardProps, commonEditFormProps) {
                var template = null;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, order = _this_props.order;
                var _this_state = this.state, isEditDeliveryOpen = _this_state.isEditDeliveryOpen, editShippingWillUnmount = _this_state.editShippingWillUnmount, shippingWillUnmount = _this_state.shippingWillUnmount, sameAddress = _this_state.sameAddress;
                var shippingAddress = userDetails.subscription && !Array.isArray(userDetails.subscription[0].shippingAddress) ? userDetails.subscription[0].shippingAddress : sameAddress ? userDetails.billingAddress : {};
                if (Object.keys(shippingAddress).length > 0) {
                    shippingAddress.gdprShipping = userDetails.gdprShipping;
                    shippingAddress.countryName = userDetails.countryNameShipping;
                }
                if (isEditDeliveryOpen) {
                    template = /*#__PURE__*/ _jsx(EditUserAddress, _object_spread({
                        classes: "edit-delivery-information",
                        title: i18n.account.deliveryAddress,
                        subTitle: i18n.account.deliveryAddressDesc,
                        order: order,
                        address: shippingAddress,
                        isDeliveryAddressForm: true,
                        willComponentUnmount: editShippingWillUnmount,
                        renderSameAddressCheckbox: this.renderSameAddressCheckbox
                    }, commonEditFormProps));
                } else {
                    template = /*#__PURE__*/ _jsx(UserAddress, _object_spread({
                        classes: "delivery-information",
                        title: sameAddress ? i18n.account.anotherDeliveryAddress : i18n.account.deliveryAddress,
                        subTitle: i18n.account.deliveryAddressDesc,
                        order: order,
                        isDeliveryAddressForm: true,
                        willComponentUnmount: shippingWillUnmount,
                        sameAddress: sameAddress,
                        address: shippingAddress,
                        userDetails: userDetails
                    }, commonInformationCardProps));
                }
                return template;
            }
        },
        {
            /**
     * Render forms in order views
     * @param commonInformationCardProps {object}
     * @param commonEditFormProps {object}
     * @param order {object}
     * @returns {ReactElement}
     */ key: "renderOrderForms",
            value: function renderOrderForms(commonInformationCardProps, commonEditFormProps, order) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "order-forms-container",
                    children: [
                        order.showBillingAddress ? this.renderBillingForm(commonInformationCardProps, commonEditFormProps) : null,
                        order.showShippingAddress ? this.renderShippingForm(commonInformationCardProps, commonEditFormProps) : null,
                        this.renderSameAddressCheckbox(false, true)
                    ]
                });
            }
        },
        {
            /**
     * Update if address cards should be open when loading the component
     * @param userDetails {object}
     * @param order {object}
     */ key: "updateAddressCardsState",
            value: function updateAddressCardsState(userDetails, order) {
                if (Object.keys(userDetails).length > 0) {
                    var billingAddress = userDetails ? userDetails.billingAddress : null;
                    var shippingAddress = userDetails.subscription && !Array.isArray(userDetails.subscription[0].shippingAddress) ? userDetails.subscription[0].shippingAddress : {};
                    var hasBillingAddress = billingAddress && billingAddress.firstName !== null;
                    var hasShippingAddress = Object.keys(shippingAddress).length > 0;
                    if (!hasBillingAddress) {
                        this.setState(function() {
                            return {
                                isEditBillingOpen: true
                            };
                        });
                    }
                    if (order) {
                        // TODO Think how to make it without setting sameAddress every time on update
                        /*if (order.showBillingAddress && order.showShippingAddress && !hasBillingAddress && !hasShippingAddress) {
            this.toggleSameAddress();
        }*/ if (!hasShippingAddress && !this.state.sameAddress && order.detailsConfig.showShipping) {
                            this.setState({
                                isEditDeliveryOpen: true
                            });
                        }
                    }
                }
            }
        },
        {
            /**
     * Adds true when ajax call is send and remove it when response is back
     * @param isLoading {boolean}
     */ key: "setUserLoad",
            value: function setUserLoad(isLoading) {
                var _this = this;
                this.setState(function(prevState) {
                    var elements = _to_consumable_array(prevState.userLoading);
                    if (isLoading) {
                        elements.push(isLoading);
                    } else {
                        elements.pop();
                        if (_this.props.order && typeof _this.props.order.toggleLoading === "function" && elements.length === 0) {
                            _this.props.order.toggleLoading(false);
                        }
                    }
                    return {
                        userLoading: _to_consumable_array(elements)
                    };
                });
            }
        },
        {
            key: "toggleMarketingNotifications",
            value: /**
     * Toggles marketing notifications on/off
     * @param event {Object}
     */ function toggleMarketingNotifications(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, enqueueSnackbar, i18n, cf_marketing, token, data, response, error, fieldError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, enqueueSnackbar = _this_props.enqueueSnackbar, i18n = _this_props.i18n;
                                cf_marketing = event.target.checked;
                                token = _this.props.authentication.token;
                                data = {
                                    token: token,
                                    cf_marketing: cf_marketing
                                };
                                _this.setState({
                                    cfMarketingRequestPending: true
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.props.editBillingDetails(data)
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.props.getFullUserDetails()
                                ];
                            case 3:
                                _state.sent();
                                _this.setState({
                                    cfMarketingRequestPending: false
                                });
                                _this.setState({
                                    cf_marketing: cf_marketing
                                });
                                try {
                                    enqueueSnackbar(cf_marketing ? i18n.snackbar.marketNotificationsOnSuccess : i18n.snackbar.marketNotificationsOffSuccess, {
                                        variant: SNACKBAR_VARIANT_SUCCESS,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                } catch (e) {
                                    console.error(e);
                                }
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                fieldError = error.error_info.description;
                                _this.setState({
                                    cfMarketingRequestPending: false
                                });
                                if (fieldError) {
                                    enqueueSnackbar(cf_marketing ? i18n.snackbar.marketNotificationsOnFail : i18n.snackbar.marketNotificationsOffFail, {
                                        variant: SNACKBAR_VARIANT_ERROR,
                                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                    });
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state = this.state, isEditBillingOpen = _this_state.isEditBillingOpen, isEditDeliveryOpen = _this_state.isEditDeliveryOpen, shouldSubmitForm = _this_state.shouldSubmitForm, sameAddress = _this_state.sameAddress, shouldToggleWithTransition = _this_state.shouldToggleWithTransition, userLoading = _this_state.userLoading, cf_marketing = _this_state.cf_marketing, cfMarketingRequestPending = _this_state.cfMarketingRequestPending;
                var _this_props = this.props, order = _this_props.order, i18n = _this_props.i18n, userDetails = _this_props.userDetails;
                var validateForms = (order || this.state).validateForms;
                var commonInformationCardProps = {
                    shouldToggleWithTransition: shouldToggleWithTransition,
                    i18n: i18n,
                    toggleEditForm: this.toggleEditForm
                };
                var commonEditFormProps = {
                    shouldToggleWithTransition: shouldToggleWithTransition,
                    isEditDeliveryOpen: isEditDeliveryOpen,
                    isEditBillingOpen: isEditBillingOpen,
                    sameAddress: sameAddress,
                    userLoading: userLoading,
                    i18n: i18n,
                    validateForms: validateForms,
                    shouldSubmitForm: shouldSubmitForm,
                    toggleEditForm: this.toggleEditForm,
                    toggleSameAddress: this.toggleSameAddress,
                    setUserLoad: this.setUserLoad,
                    setFormValidity: this.setFormValidity,
                    allowFormSubmit: this.allowFormSubmit,
                    callbackOnSuccessfulAddressChange: this.callbackOnSuccessfulAddressChange
                };
                return /*#__PURE__*/ _jsx("div", {
                    className: "profile-wrapper".concat(order ? "" : " profile"),
                    children: !order ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            this.renderBillingForm(commonInformationCardProps, commonEditFormProps),
                            DELIVERY_FORM_ENABLED && this.renderShippingForm(commonInformationCardProps, commonEditFormProps),
                            !isEditDeliveryOpen && !isEditBillingOpen ? /*#__PURE__*/ _jsxs("div", {
                                className: "checkboxes-container",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "promotions-checkbox".concat(cfMarketingRequestPending ? " disabled" : ""),
                                        children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                            control: /*#__PURE__*/ _jsx(Checkbox, {
                                                classes: {
                                                    checked: "ux-checked"
                                                },
                                                id: "cf_marketing",
                                                type: "checkbox",
                                                disabled: cfMarketingRequestPending || typeof userDetails.cf_marketing === "undefined",
                                                checked: cf_marketing,
                                                onChange: this.toggleMarketingNotifications,
                                                value: "cf_marketing"
                                            }),
                                            label: i18n.authentication.wantNotifications,
                                            classes: {
                                                root: "ux-checkbox-label-root",
                                                label: "ux-checkbox-label tiny-font"
                                            }
                                        })
                                    }),
                                    DELIVERY_FORM_ENABLED && this.renderSameAddressCheckbox(false, true)
                                ]
                            }) : null,
                            this.renderAccountFooter()
                        ]
                    }) : this.renderOrderForms(commonInformationCardProps, commonEditFormProps, order)
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this_props = this.props, userDetails = _this_props.userDetails, order = _this_props.order;
                this.updateAddressCardsState(userDetails, order);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var userDetails = nextProps.userDetails, order = nextProps.order;
                if (userDetails.cf_marketing !== this.props.userDetails.cf_marketing) {
                    this.setState({
                        cf_marketing: userDetails.cf_marketing
                    });
                }
                if ((userDetails !== this.props.userDetails || order !== this.props.order) && userDetails.cf_marketing === this.props.userDetails.cf_marketing) {
                    this.updateAddressCardsState(userDetails, order);
                    if (userDetails.sameAddress !== this.props.userDetails.sameAddress) {
                        this.setState({
                            sameAddress: userDetails.sameAddress
                        });
                    }
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this = this;
                var _prevProps_userDetails;
                var _this_props = this.props, order = _this_props.order, userDetails = _this_props.userDetails;
                var prevBillingAddress = ((_prevProps_userDetails = prevProps.userDetails) === null || _prevProps_userDetails === void 0 ? void 0 : _prevProps_userDetails.billingAddress) ? prevProps.userDetails.billingAddress : {};
                var billingAddress = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.billingAddress) ? userDetails.billingAddress : {};
                if (prevBillingAddress.firstName !== billingAddress.firstName) {
                    var hasBillingAddress = userDetails.billingAddress && userDetails.billingAddress.firstName !== null;
                // this.setState({ isEditBillingOpen: !hasBillingAddress });
                }
                if (!prevState.isEditDeliveryOpen && this.state.isEditDeliveryOpen && this.state.sameAddress) {
                    this.setState(function() {
                        return {
                            sameAddress: !_this.state.sameAddress
                        };
                    });
                }
                if (this.state.isEditDeliveryOpen && !prevState.sameAddress && this.state.sameAddress && prevState.sameAddress !== this.state.sameAddress && prevState.isEditDeliveryOpen !== this.state.isEditDeliveryOpen) {
                    this.toggleEditForm(DELIVERY_FORM);
                }
                var validateForms = (order || this.state).validateForms;
                if (validateForms) {
                    // If the profile component is rendered in order
                    // and the two forms are not open for edit when validateForms
                    // is called, call success function
                    if (order) {
                        if (!this.state.isEditBillingOpen) {
                            order.callbackOnSuccessfulAddressChange(BILLING_FORM_TYPE, true);
                        }
                        if (!this.state.isEditDeliveryOpen) {
                            order.callbackOnSuccessfulAddressChange(DELIVERY_FORM_TYPE, true);
                        }
                        order.toggleValidateForms(false);
                    } else {
                        this.validateForms(false);
                    }
                }
                if (this.state.isBillingFormValid && this.state.isDeliveryFormValid) {
                    this.allowFormSubmit(true);
                    this.setState({
                        isBillingFormValid: false,
                        isDeliveryFormValid: false
                    });
                    if (order && typeof order.toggleLoading === "function") {
                        order.toggleLoading(true);
                    }
                }
            }
        }
    ]);
    return ProfileInformation;
}(Component);
var mapStateToProps = function(param) {
    var authentication = param.authentication, i18n = param.i18n, userDetails = param.userDetails;
    return {
        authentication: authentication,
        i18n: i18n,
        userDetails: userDetails
    };
};
export default withSnackbar(connect(mapStateToProps, {
    editBillingDetails: editBillingDetails,
    getFullUserDetails: getFullUserDetails,
    closeModal: closeModal
})(ProfileInformation));
